/* tslint:disable */
import {
  Account,
  Contact,
  GeoMetro,
  Task,
  Worker,
  CountryCode,
  JobOffers,
  JobOrder,
  Source,
  ApplicationAssessment,
  SOWDetail
} from '../index';

declare var Object: any;
export interface JobApplicationInterface {
  "sfdcId"?: string;
  "Applied_Date_on_Taleo__c"?: Date;
  "Create_Service_Contract__c"?: boolean;
  "CreatedById"?: string;
  "CreatedBy__c"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "Driving_Distance_From_Jobsite__c"?: number;
  "Driving_Time__c"?: string;
  "GEO_Code__c"?: string;
  "Hiring_Manager__c"?: string;
  "IsDeleted"?: boolean;
  "Jobsite__c"?: string;
  "LastActivityDate"?: Date;
  "LastModifiedById"?: string;
  "LastModifiedBy__c"?: string;
  "LastModifiedDate"?: Date;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "Name"?: string;
  "Overall_Health_for_Service_Contract__c"?: boolean;
  "Placement_Reference__c"?: string;
  "Primary_Recruiter__c"?: string;
  "Product__c"?: string;
  "Project_Name__c"?: string;
  "RecordTypeId"?: string;
  "Secondary_Recruiter__c"?: string;
  "Sent_Email__c"?: boolean;
  "Service_Contract_Created__c"?: boolean;
  "Talent_Type__c"?: string;
  "Taleo_Job_Id_Ref__c"?: string;
  "ts2__AccountContact__c"?: string;
  "ts2__Account__c"?: string;
  "ts2__Address__c"?: string;
  "ts2__Agency__c"?: string;
  "ts2__App_Status__c"?: string;
  "ts2__App_Tags__c"?: string;
  "ts2__Application_Source__c"?: string;
  "ts2__Application_Status__c"?: string;
  "ts2__Apply_Agency__c"?: boolean;
  "ts2__Apply_Exception__c"?: boolean;
  "ts2__Candidate_Contact__c"?: string;
  "ts2__Candidate_Source__c"?: string;
  "ts2__Client__c"?: string;
  "ts2__Code__c"?: string;
  "ts2__Completed__c"?: boolean;
  "ts2__Contact_Email__c"?: string;
  "ts2__Contact_Phone__c"?: string;
  "ts2__Contact__c"?: string;
  "ts2__Cover_Letter__c"?: string;
  "ts2__Custom_Email_Message__c"?: string;
  "ts2__Date_Available__c"?: Date;
  "ts2__Disposition_Value__c"?: string;
  "ts2__EEO_Disabled_Received__c"?: string;
  "ts2__EEO_Disabled__c"?: string;
  "ts2__EEO_Gender_Received__c"?: string;
  "ts2__EEO_Gender__c"?: string;
  "ts2__EEO_Race_Received__c"?: string;
  "ts2__EEO_Veteran_Status_Received__c"?: string;
  "ts2__Email__c"?: string;
  "ts2__Exception_Reason_Other__c"?: string;
  "ts2__Exception_Reason__c"?: string;
  "ts2__Experience_Sum__c"?: string;
  "ts2__HiringManager__c"?: string;
  "ts2__Internally_Applied__c"?: boolean;
  "ts2__Invite_to_Apply__c"?: boolean;
  "ts2__Job_Board__c"?: string;
  "ts2__Job_Status__c"?: string;
  "ts2__Job__c"?: string;
  "ts2__Legacy_ApplicationID__c"?: string;
  "ts2__Mobile__c"?: string;
  "ts2__Overall_Reject_Detail__c"?: string;
  "ts2__Overall_Reject_Reason__c"?: string;
  "ts2__Phone__c"?: string;
  "ts2__Prescreen_Score__c"?: number;
  "ts2__PrimaryRecruiter__c"?: string;
  "ts2__Project__c"?: string;
  "ts2__Race__c"?: string;
  "ts2__Rank__c"?: string;
  "ts2__Reject_Detail__c"?: string;
  "ts2__Reject_Reason__c"?: string;
  "ts2__Request_EEO__c"?: boolean;
  "ts2__Revert_Status__c"?: string;
  "ts2__Rollover_Job_Order__c"?: string;
  "ts2__Rollover__c"?: boolean;
  "ts2__Score__c"?: number;
  "ts2__SecondaryRecruiter__c"?: string;
  "ts2__Stage__c"?: string;
  "ts2__Status__c"?: string;
  "ts2__Tracking_Source__c"?: string;
  "ts2__Veteran_Status__c"?: string;
  "ts2__referral_id__c"?: string;
  "ts2__referred_by__c"?: string;
  "ts2extams__Action_Buttons__c"?: string;
  "ts2extams__Application_Matched__c"?: boolean;
  "ts2extams__Communication_Buttons__c"?: string;
  "ts2extams__Control_Buttons__c"?: string;
  "ts2extams__Go_To_Current_Stage__c"?: string;
  "ts2extams__Overall_SubStatus_API_Name__c"?: string;
  "ts2extams__Overall_SubStatus_Id__c"?: string;
  "ts2extams__Overall_SubStatus_Link__c"?: string;
  "ts2extams__Resume_Uploaded__c"?: string;
  "ts2extams__Substatus__c"?: string;
  "ts2extams__Translated_Substatus__c"?: string;
  "candidate_currency__c"?: string;
  "candidate_salary__c"?: string;
  "candidate_salary_term__c"?: string;
  "Job_Order_Open__c"?: string;
  "notice_period__c"?: string;
  "Overall_Health_Check__c"?: string;
  "Pay_Rate__c"?: string;
  "Feedback_Flag__c"?: boolean;
  "Interview_Feedback__c"?: string;
  "IsPlacementStarted__c"?: boolean;
  "Job_Stability_Rating_Health_Check__c"?: string;
  "Job_Stability_Rating__c"?: number;
  "LinkedIn_Profile_Health__c"?: string;
  "Stability_Long_Health__c"?: string;
  "Stability_Short_Health__c"?: string;
  "Template_Format_Formula__c"?: string;
  "Candidate_Vendor_Pay_Rate_Negotiatio__c"?: number;
  "Candidate_Type__c"?: string;
  "Reason__c"?: string;
  "Aptitude_Test_Score__c"?: number;
  "English_Test_Score__c"?: number;
  "Can_candidate_Relocate_to_Jobsite__c"?: string;
  "Candidate_Prescreening_Health__c"?: boolean;
  "Candidate_Prescreening_Health_Check__c"?: string;
  "Employment_Type__c"?: string;
  "English_Language_Proficiency__c"?: string;
  "Local_Language__c"?: string;
  "Local_Language_Proficiency__c"?: string;
  "Type_of_work_Visa_authorization__c"?: string;
  "Linkedin_Invite_Status__c"?: string;
  "Prescreening_created_Date_and_Time__c"?: Date;
  "Submit_for_Financal_Approval_Date_Time__c"?: Date;
  "Finance_Approval__c"?: string;
  "Finance_Approval_Status__c"?: string;
  "Finance_Approver_Name__c"?: string;
  "Custom_Price__c"?: boolean;
  "Gross_Margin__c"?: number;
  "Vendor_Annual_Rate__c"?: number;
  "Vendor_FTE_Daily_Rate_Standard__c"?: number;
  "Vendor_FTE_Half_Day_Rate__c"?: number;
  "Vendor_FTE_Hourly_Rate_Holiday__c"?: number;
  "Vendor_FTE_Hourly_Rate_Overtime__c"?: number;
  "Vendor_FTE_Monthly_Rate__c"?: number;
  "Vendor_Hourly_Rate__c"?: number;
  "GrossMargin__c"?: number;
  "Vendor_FTE_Weekly_Rate__c"?: number;
  "TPMO_Approval_Check__c"?: boolean;
  "TPMO_Approval__c"?: string;
  "Joining_Bonus__c"?: number;
  "MBO_Bonus__c"?: number;
  "Other_Bonus__c"?: number;
  "Offered_Vacation_PTOs__c"?: number;
  "Offered_Sick_Leaves__c"?: number;
  "Public_holidays__c"?: number;
  "Health_Insurance__c"?: string;
  "Health_Insurance_Contribution__c"?: string;
  "Any_Other_Benefit__c"?: string;
  "Does_this_candidate_now_or_in_future_nee__c"?: string;
  "Job_Status__c"?: string;
  "Hiring_Entity_Name__c"?: string;
  "Hiring_Entity_Country__c"?: string;
  "Relocation_Expense_In_Any__c"?: number;
  "Standard_Benefit_Packet__c"?: string;
  "Dental_Coverage__c"?: number;
  "Budget_for_Counter_Offer__c"?: number;
  "Medical_Coverage__c"?: number;
  "Vision_Coverage__c"?: number;
  "SOW_Detail__c"?: string;
  "RTR_End_Date__c"?: Date;
  "RTR_Start_Date__c"?: Date;
  "FTE_Employment_Category__c"?: string;
  "Bypass_RTR__c"?: boolean;
  "Candidate_Vaccination_Status__c"?: string;
  "Bypass_Covid_Vaccination_Check__c"?: boolean;
  "Reason_for_Covid_Vaccination_Bypass__c"?: string;
  "Right_to_Represent__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  account?: Account;
  contact?: Contact;
  hrManager?: Contact;
  geoMetro?: GeoMetro;
  createdBy?: Contact;
  agency?: Account;
  tasks?: Task[];
  primaryRecruiter?: Contact;
  lastModifiedBy?: Contact;
  worker?: Worker;
  hiringEntityCountry?: CountryCode;
  jobOffers?: JobOffers[];
  jobOrder?: JobOrder;
  source?: Source;
  applicationAssesment?: ApplicationAssessment[];
  vendorSows?: SOWDetail;
}

export class JobApplication implements JobApplicationInterface {
  "sfdcId": string;
  "Applied_Date_on_Taleo__c": Date;
  "Create_Service_Contract__c": boolean;
  "CreatedById": string;
  "CreatedBy__c": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "Driving_Distance_From_Jobsite__c": number;
  "Driving_Time__c": string;
  "GEO_Code__c": string;
  "Hiring_Manager__c": string;
  "IsDeleted": boolean;
  "Jobsite__c": string;
  "LastActivityDate": Date;
  "LastModifiedById": string;
  "LastModifiedBy__c": string;
  "LastModifiedDate": Date;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "Name": string;
  "Overall_Health_for_Service_Contract__c": boolean;
  "Placement_Reference__c": string;
  "Primary_Recruiter__c": string;
  "Product__c": string;
  "Project_Name__c": string;
  "RecordTypeId": string;
  "Secondary_Recruiter__c": string;
  "Sent_Email__c": boolean;
  "Service_Contract_Created__c": boolean;
  "Talent_Type__c": string;
  "Taleo_Job_Id_Ref__c": string;
  "ts2__AccountContact__c": string;
  "ts2__Account__c": string;
  "ts2__Address__c": string;
  "ts2__Agency__c": string;
  "ts2__App_Status__c": string;
  "ts2__App_Tags__c": string;
  "ts2__Application_Source__c": string;
  "ts2__Application_Status__c": string;
  "ts2__Apply_Agency__c": boolean;
  "ts2__Apply_Exception__c": boolean;
  "ts2__Candidate_Contact__c": string;
  "ts2__Candidate_Source__c": string;
  "ts2__Client__c": string;
  "ts2__Code__c": string;
  "ts2__Completed__c": boolean;
  "ts2__Contact_Email__c": string;
  "ts2__Contact_Phone__c": string;
  "ts2__Contact__c": string;
  "ts2__Cover_Letter__c": string;
  "ts2__Custom_Email_Message__c": string;
  "ts2__Date_Available__c": Date;
  "ts2__Disposition_Value__c": string;
  "ts2__EEO_Disabled_Received__c": string;
  "ts2__EEO_Disabled__c": string;
  "ts2__EEO_Gender_Received__c": string;
  "ts2__EEO_Gender__c": string;
  "ts2__EEO_Race_Received__c": string;
  "ts2__EEO_Veteran_Status_Received__c": string;
  "ts2__Email__c": string;
  "ts2__Exception_Reason_Other__c": string;
  "ts2__Exception_Reason__c": string;
  "ts2__Experience_Sum__c": string;
  "ts2__HiringManager__c": string;
  "ts2__Internally_Applied__c": boolean;
  "ts2__Invite_to_Apply__c": boolean;
  "ts2__Job_Board__c": string;
  "ts2__Job_Status__c": string;
  "ts2__Job__c": string;
  "ts2__Legacy_ApplicationID__c": string;
  "ts2__Mobile__c": string;
  "ts2__Overall_Reject_Detail__c": string;
  "ts2__Overall_Reject_Reason__c": string;
  "ts2__Phone__c": string;
  "ts2__Prescreen_Score__c": number;
  "ts2__PrimaryRecruiter__c": string;
  "ts2__Project__c": string;
  "ts2__Race__c": string;
  "ts2__Rank__c": string;
  "ts2__Reject_Detail__c": string;
  "ts2__Reject_Reason__c": string;
  "ts2__Request_EEO__c": boolean;
  "ts2__Revert_Status__c": string;
  "ts2__Rollover_Job_Order__c": string;
  "ts2__Rollover__c": boolean;
  "ts2__Score__c": number;
  "ts2__SecondaryRecruiter__c": string;
  "ts2__Stage__c": string;
  "ts2__Status__c": string;
  "ts2__Tracking_Source__c": string;
  "ts2__Veteran_Status__c": string;
  "ts2__referral_id__c": string;
  "ts2__referred_by__c": string;
  "ts2extams__Action_Buttons__c": string;
  "ts2extams__Application_Matched__c": boolean;
  "ts2extams__Communication_Buttons__c": string;
  "ts2extams__Control_Buttons__c": string;
  "ts2extams__Go_To_Current_Stage__c": string;
  "ts2extams__Overall_SubStatus_API_Name__c": string;
  "ts2extams__Overall_SubStatus_Id__c": string;
  "ts2extams__Overall_SubStatus_Link__c": string;
  "ts2extams__Resume_Uploaded__c": string;
  "ts2extams__Substatus__c": string;
  "ts2extams__Translated_Substatus__c": string;
  "candidate_currency__c": string;
  "candidate_salary__c": string;
  "candidate_salary_term__c": string;
  "Job_Order_Open__c": string;
  "notice_period__c": string;
  "Overall_Health_Check__c": string;
  "Pay_Rate__c": string;
  "Feedback_Flag__c": boolean;
  "Interview_Feedback__c": string;
  "IsPlacementStarted__c": boolean;
  "Job_Stability_Rating_Health_Check__c": string;
  "Job_Stability_Rating__c": number;
  "LinkedIn_Profile_Health__c": string;
  "Stability_Long_Health__c": string;
  "Stability_Short_Health__c": string;
  "Template_Format_Formula__c": string;
  "Candidate_Vendor_Pay_Rate_Negotiatio__c": number;
  "Candidate_Type__c": string;
  "Reason__c": string;
  "Aptitude_Test_Score__c": number;
  "English_Test_Score__c": number;
  "Can_candidate_Relocate_to_Jobsite__c": string;
  "Candidate_Prescreening_Health__c": boolean;
  "Candidate_Prescreening_Health_Check__c": string;
  "Employment_Type__c": string;
  "English_Language_Proficiency__c": string;
  "Local_Language__c": string;
  "Local_Language_Proficiency__c": string;
  "Type_of_work_Visa_authorization__c": string;
  "Linkedin_Invite_Status__c": string;
  "Prescreening_created_Date_and_Time__c": Date;
  "Submit_for_Financal_Approval_Date_Time__c": Date;
  "Finance_Approval__c": string;
  "Finance_Approval_Status__c": string;
  "Finance_Approver_Name__c": string;
  "Custom_Price__c": boolean;
  "Gross_Margin__c": number;
  "Vendor_Annual_Rate__c": number;
  "Vendor_FTE_Daily_Rate_Standard__c": number;
  "Vendor_FTE_Half_Day_Rate__c": number;
  "Vendor_FTE_Hourly_Rate_Holiday__c": number;
  "Vendor_FTE_Hourly_Rate_Overtime__c": number;
  "Vendor_FTE_Monthly_Rate__c": number;
  "Vendor_Hourly_Rate__c": number;
  "GrossMargin__c": number;
  "Vendor_FTE_Weekly_Rate__c": number;
  "TPMO_Approval_Check__c": boolean;
  "TPMO_Approval__c": string;
  "Joining_Bonus__c": number;
  "MBO_Bonus__c": number;
  "Other_Bonus__c": number;
  "Offered_Vacation_PTOs__c": number;
  "Offered_Sick_Leaves__c": number;
  "Public_holidays__c": number;
  "Health_Insurance__c": string;
  "Health_Insurance_Contribution__c": string;
  "Any_Other_Benefit__c": string;
  "Does_this_candidate_now_or_in_future_nee__c": string;
  "Job_Status__c": string;
  "Hiring_Entity_Name__c": string;
  "Hiring_Entity_Country__c": string;
  "Relocation_Expense_In_Any__c": number;
  "Standard_Benefit_Packet__c": string;
  "Dental_Coverage__c": number;
  "Budget_for_Counter_Offer__c": number;
  "Medical_Coverage__c": number;
  "Vision_Coverage__c": number;
  "SOW_Detail__c": string;
  "RTR_End_Date__c": Date;
  "RTR_Start_Date__c": Date;
  "FTE_Employment_Category__c": string;
  "Bypass_RTR__c": boolean;
  "Candidate_Vaccination_Status__c": string;
  "Bypass_Covid_Vaccination_Check__c": boolean;
  "Reason_for_Covid_Vaccination_Bypass__c": string;
  "Right_to_Represent__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  account: Account;
  contact: Contact;
  hrManager: Contact;
  geoMetro: GeoMetro;
  createdBy: Contact;
  agency: Account;
  tasks: Task[];
  primaryRecruiter: Contact;
  lastModifiedBy: Contact;
  worker: Worker;
  hiringEntityCountry: CountryCode;
  jobOffers: JobOffers[];
  jobOrder: JobOrder;
  source: Source;
  applicationAssesment: ApplicationAssessment[];
  vendorSows: SOWDetail;
  constructor(data?: JobApplicationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobApplication`.
   */
  public static getModelName() {
    return "JobApplication";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobApplication for dynamic purposes.
  **/
  public static factory(data: JobApplicationInterface): JobApplication{
    return new JobApplication(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobApplication',
      plural: 'JobApplications',
      path: 'JobApplications',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Applied_Date_on_Taleo__c": {
          name: 'Applied_Date_on_Taleo__c',
          type: 'Date'
        },
        "Create_Service_Contract__c": {
          name: 'Create_Service_Contract__c',
          type: 'boolean',
          default: false
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Driving_Distance_From_Jobsite__c": {
          name: 'Driving_Distance_From_Jobsite__c',
          type: 'number'
        },
        "Driving_Time__c": {
          name: 'Driving_Time__c',
          type: 'string'
        },
        "GEO_Code__c": {
          name: 'GEO_Code__c',
          type: 'string'
        },
        "Hiring_Manager__c": {
          name: 'Hiring_Manager__c',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean',
          default: false
        },
        "Jobsite__c": {
          name: 'Jobsite__c',
          type: 'string'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Overall_Health_for_Service_Contract__c": {
          name: 'Overall_Health_for_Service_Contract__c',
          type: 'boolean'
        },
        "Placement_Reference__c": {
          name: 'Placement_Reference__c',
          type: 'string'
        },
        "Primary_Recruiter__c": {
          name: 'Primary_Recruiter__c',
          type: 'string'
        },
        "Product__c": {
          name: 'Product__c',
          type: 'string'
        },
        "Project_Name__c": {
          name: 'Project_Name__c',
          type: 'string'
        },
        "RecordTypeId": {
          name: 'RecordTypeId',
          type: 'string'
        },
        "Secondary_Recruiter__c": {
          name: 'Secondary_Recruiter__c',
          type: 'string'
        },
        "Sent_Email__c": {
          name: 'Sent_Email__c',
          type: 'boolean',
          default: false
        },
        "Service_Contract_Created__c": {
          name: 'Service_Contract_Created__c',
          type: 'boolean',
          default: false
        },
        "Talent_Type__c": {
          name: 'Talent_Type__c',
          type: 'string'
        },
        "Taleo_Job_Id_Ref__c": {
          name: 'Taleo_Job_Id_Ref__c',
          type: 'string'
        },
        "ts2__AccountContact__c": {
          name: 'ts2__AccountContact__c',
          type: 'string'
        },
        "ts2__Account__c": {
          name: 'ts2__Account__c',
          type: 'string'
        },
        "ts2__Address__c": {
          name: 'ts2__Address__c',
          type: 'string'
        },
        "ts2__Agency__c": {
          name: 'ts2__Agency__c',
          type: 'string'
        },
        "ts2__App_Status__c": {
          name: 'ts2__App_Status__c',
          type: 'string'
        },
        "ts2__App_Tags__c": {
          name: 'ts2__App_Tags__c',
          type: 'string'
        },
        "ts2__Application_Source__c": {
          name: 'ts2__Application_Source__c',
          type: 'string'
        },
        "ts2__Application_Status__c": {
          name: 'ts2__Application_Status__c',
          type: 'string'
        },
        "ts2__Apply_Agency__c": {
          name: 'ts2__Apply_Agency__c',
          type: 'boolean',
          default: false
        },
        "ts2__Apply_Exception__c": {
          name: 'ts2__Apply_Exception__c',
          type: 'boolean',
          default: false
        },
        "ts2__Candidate_Contact__c": {
          name: 'ts2__Candidate_Contact__c',
          type: 'string'
        },
        "ts2__Candidate_Source__c": {
          name: 'ts2__Candidate_Source__c',
          type: 'string'
        },
        "ts2__Client__c": {
          name: 'ts2__Client__c',
          type: 'string'
        },
        "ts2__Code__c": {
          name: 'ts2__Code__c',
          type: 'string'
        },
        "ts2__Completed__c": {
          name: 'ts2__Completed__c',
          type: 'boolean',
          default: false
        },
        "ts2__Contact_Email__c": {
          name: 'ts2__Contact_Email__c',
          type: 'string'
        },
        "ts2__Contact_Phone__c": {
          name: 'ts2__Contact_Phone__c',
          type: 'string'
        },
        "ts2__Contact__c": {
          name: 'ts2__Contact__c',
          type: 'string'
        },
        "ts2__Cover_Letter__c": {
          name: 'ts2__Cover_Letter__c',
          type: 'string'
        },
        "ts2__Custom_Email_Message__c": {
          name: 'ts2__Custom_Email_Message__c',
          type: 'string'
        },
        "ts2__Date_Available__c": {
          name: 'ts2__Date_Available__c',
          type: 'Date'
        },
        "ts2__Disposition_Value__c": {
          name: 'ts2__Disposition_Value__c',
          type: 'string'
        },
        "ts2__EEO_Disabled_Received__c": {
          name: 'ts2__EEO_Disabled_Received__c',
          type: 'string'
        },
        "ts2__EEO_Disabled__c": {
          name: 'ts2__EEO_Disabled__c',
          type: 'string'
        },
        "ts2__EEO_Gender_Received__c": {
          name: 'ts2__EEO_Gender_Received__c',
          type: 'string'
        },
        "ts2__EEO_Gender__c": {
          name: 'ts2__EEO_Gender__c',
          type: 'string'
        },
        "ts2__EEO_Race_Received__c": {
          name: 'ts2__EEO_Race_Received__c',
          type: 'string'
        },
        "ts2__EEO_Veteran_Status_Received__c": {
          name: 'ts2__EEO_Veteran_Status_Received__c',
          type: 'string'
        },
        "ts2__Email__c": {
          name: 'ts2__Email__c',
          type: 'string'
        },
        "ts2__Exception_Reason_Other__c": {
          name: 'ts2__Exception_Reason_Other__c',
          type: 'string'
        },
        "ts2__Exception_Reason__c": {
          name: 'ts2__Exception_Reason__c',
          type: 'string'
        },
        "ts2__Experience_Sum__c": {
          name: 'ts2__Experience_Sum__c',
          type: 'string'
        },
        "ts2__HiringManager__c": {
          name: 'ts2__HiringManager__c',
          type: 'string'
        },
        "ts2__Internally_Applied__c": {
          name: 'ts2__Internally_Applied__c',
          type: 'boolean',
          default: false
        },
        "ts2__Invite_to_Apply__c": {
          name: 'ts2__Invite_to_Apply__c',
          type: 'boolean',
          default: false
        },
        "ts2__Job_Board__c": {
          name: 'ts2__Job_Board__c',
          type: 'string'
        },
        "ts2__Job_Status__c": {
          name: 'ts2__Job_Status__c',
          type: 'string'
        },
        "ts2__Job__c": {
          name: 'ts2__Job__c',
          type: 'string'
        },
        "ts2__Legacy_ApplicationID__c": {
          name: 'ts2__Legacy_ApplicationID__c',
          type: 'string'
        },
        "ts2__Mobile__c": {
          name: 'ts2__Mobile__c',
          type: 'string'
        },
        "ts2__Overall_Reject_Detail__c": {
          name: 'ts2__Overall_Reject_Detail__c',
          type: 'string'
        },
        "ts2__Overall_Reject_Reason__c": {
          name: 'ts2__Overall_Reject_Reason__c',
          type: 'string'
        },
        "ts2__Phone__c": {
          name: 'ts2__Phone__c',
          type: 'string'
        },
        "ts2__Prescreen_Score__c": {
          name: 'ts2__Prescreen_Score__c',
          type: 'number'
        },
        "ts2__PrimaryRecruiter__c": {
          name: 'ts2__PrimaryRecruiter__c',
          type: 'string'
        },
        "ts2__Project__c": {
          name: 'ts2__Project__c',
          type: 'string'
        },
        "ts2__Race__c": {
          name: 'ts2__Race__c',
          type: 'string'
        },
        "ts2__Rank__c": {
          name: 'ts2__Rank__c',
          type: 'string'
        },
        "ts2__Reject_Detail__c": {
          name: 'ts2__Reject_Detail__c',
          type: 'string'
        },
        "ts2__Reject_Reason__c": {
          name: 'ts2__Reject_Reason__c',
          type: 'string'
        },
        "ts2__Request_EEO__c": {
          name: 'ts2__Request_EEO__c',
          type: 'boolean',
          default: false
        },
        "ts2__Revert_Status__c": {
          name: 'ts2__Revert_Status__c',
          type: 'string'
        },
        "ts2__Rollover_Job_Order__c": {
          name: 'ts2__Rollover_Job_Order__c',
          type: 'string'
        },
        "ts2__Rollover__c": {
          name: 'ts2__Rollover__c',
          type: 'boolean',
          default: false
        },
        "ts2__Score__c": {
          name: 'ts2__Score__c',
          type: 'number'
        },
        "ts2__SecondaryRecruiter__c": {
          name: 'ts2__SecondaryRecruiter__c',
          type: 'string'
        },
        "ts2__Stage__c": {
          name: 'ts2__Stage__c',
          type: 'string'
        },
        "ts2__Status__c": {
          name: 'ts2__Status__c',
          type: 'string'
        },
        "ts2__Tracking_Source__c": {
          name: 'ts2__Tracking_Source__c',
          type: 'string'
        },
        "ts2__Veteran_Status__c": {
          name: 'ts2__Veteran_Status__c',
          type: 'string'
        },
        "ts2__referral_id__c": {
          name: 'ts2__referral_id__c',
          type: 'string'
        },
        "ts2__referred_by__c": {
          name: 'ts2__referred_by__c',
          type: 'string'
        },
        "ts2extams__Action_Buttons__c": {
          name: 'ts2extams__Action_Buttons__c',
          type: 'string'
        },
        "ts2extams__Application_Matched__c": {
          name: 'ts2extams__Application_Matched__c',
          type: 'boolean',
          default: false
        },
        "ts2extams__Communication_Buttons__c": {
          name: 'ts2extams__Communication_Buttons__c',
          type: 'string'
        },
        "ts2extams__Control_Buttons__c": {
          name: 'ts2extams__Control_Buttons__c',
          type: 'string'
        },
        "ts2extams__Go_To_Current_Stage__c": {
          name: 'ts2extams__Go_To_Current_Stage__c',
          type: 'string'
        },
        "ts2extams__Overall_SubStatus_API_Name__c": {
          name: 'ts2extams__Overall_SubStatus_API_Name__c',
          type: 'string'
        },
        "ts2extams__Overall_SubStatus_Id__c": {
          name: 'ts2extams__Overall_SubStatus_Id__c',
          type: 'string'
        },
        "ts2extams__Overall_SubStatus_Link__c": {
          name: 'ts2extams__Overall_SubStatus_Link__c',
          type: 'string'
        },
        "ts2extams__Resume_Uploaded__c": {
          name: 'ts2extams__Resume_Uploaded__c',
          type: 'string'
        },
        "ts2extams__Substatus__c": {
          name: 'ts2extams__Substatus__c',
          type: 'string'
        },
        "ts2extams__Translated_Substatus__c": {
          name: 'ts2extams__Translated_Substatus__c',
          type: 'string'
        },
        "candidate_currency__c": {
          name: 'candidate_currency__c',
          type: 'string'
        },
        "candidate_salary__c": {
          name: 'candidate_salary__c',
          type: 'string'
        },
        "candidate_salary_term__c": {
          name: 'candidate_salary_term__c',
          type: 'string'
        },
        "Job_Order_Open__c": {
          name: 'Job_Order_Open__c',
          type: 'string'
        },
        "notice_period__c": {
          name: 'notice_period__c',
          type: 'string'
        },
        "Overall_Health_Check__c": {
          name: 'Overall_Health_Check__c',
          type: 'string'
        },
        "Pay_Rate__c": {
          name: 'Pay_Rate__c',
          type: 'string'
        },
        "Feedback_Flag__c": {
          name: 'Feedback_Flag__c',
          type: 'boolean'
        },
        "Interview_Feedback__c": {
          name: 'Interview_Feedback__c',
          type: 'string'
        },
        "IsPlacementStarted__c": {
          name: 'IsPlacementStarted__c',
          type: 'boolean'
        },
        "Job_Stability_Rating_Health_Check__c": {
          name: 'Job_Stability_Rating_Health_Check__c',
          type: 'string'
        },
        "Job_Stability_Rating__c": {
          name: 'Job_Stability_Rating__c',
          type: 'number'
        },
        "LinkedIn_Profile_Health__c": {
          name: 'LinkedIn_Profile_Health__c',
          type: 'string'
        },
        "Stability_Long_Health__c": {
          name: 'Stability_Long_Health__c',
          type: 'string'
        },
        "Stability_Short_Health__c": {
          name: 'Stability_Short_Health__c',
          type: 'string'
        },
        "Template_Format_Formula__c": {
          name: 'Template_Format_Formula__c',
          type: 'string'
        },
        "Candidate_Vendor_Pay_Rate_Negotiatio__c": {
          name: 'Candidate_Vendor_Pay_Rate_Negotiatio__c',
          type: 'number'
        },
        "Candidate_Type__c": {
          name: 'Candidate_Type__c',
          type: 'string'
        },
        "Reason__c": {
          name: 'Reason__c',
          type: 'string'
        },
        "Aptitude_Test_Score__c": {
          name: 'Aptitude_Test_Score__c',
          type: 'number'
        },
        "English_Test_Score__c": {
          name: 'English_Test_Score__c',
          type: 'number'
        },
        "Can_candidate_Relocate_to_Jobsite__c": {
          name: 'Can_candidate_Relocate_to_Jobsite__c',
          type: 'string'
        },
        "Candidate_Prescreening_Health__c": {
          name: 'Candidate_Prescreening_Health__c',
          type: 'boolean'
        },
        "Candidate_Prescreening_Health_Check__c": {
          name: 'Candidate_Prescreening_Health_Check__c',
          type: 'string'
        },
        "Employment_Type__c": {
          name: 'Employment_Type__c',
          type: 'string'
        },
        "English_Language_Proficiency__c": {
          name: 'English_Language_Proficiency__c',
          type: 'string'
        },
        "Local_Language__c": {
          name: 'Local_Language__c',
          type: 'string'
        },
        "Local_Language_Proficiency__c": {
          name: 'Local_Language_Proficiency__c',
          type: 'string'
        },
        "Type_of_work_Visa_authorization__c": {
          name: 'Type_of_work_Visa_authorization__c',
          type: 'string'
        },
        "Linkedin_Invite_Status__c": {
          name: 'Linkedin_Invite_Status__c',
          type: 'string'
        },
        "Prescreening_created_Date_and_Time__c": {
          name: 'Prescreening_created_Date_and_Time__c',
          type: 'Date'
        },
        "Submit_for_Financal_Approval_Date_Time__c": {
          name: 'Submit_for_Financal_Approval_Date_Time__c',
          type: 'Date'
        },
        "Finance_Approval__c": {
          name: 'Finance_Approval__c',
          type: 'string'
        },
        "Finance_Approval_Status__c": {
          name: 'Finance_Approval_Status__c',
          type: 'string'
        },
        "Finance_Approver_Name__c": {
          name: 'Finance_Approver_Name__c',
          type: 'string'
        },
        "Custom_Price__c": {
          name: 'Custom_Price__c',
          type: 'boolean'
        },
        "Gross_Margin__c": {
          name: 'Gross_Margin__c',
          type: 'number'
        },
        "Vendor_Annual_Rate__c": {
          name: 'Vendor_Annual_Rate__c',
          type: 'number'
        },
        "Vendor_FTE_Daily_Rate_Standard__c": {
          name: 'Vendor_FTE_Daily_Rate_Standard__c',
          type: 'number'
        },
        "Vendor_FTE_Half_Day_Rate__c": {
          name: 'Vendor_FTE_Half_Day_Rate__c',
          type: 'number'
        },
        "Vendor_FTE_Hourly_Rate_Holiday__c": {
          name: 'Vendor_FTE_Hourly_Rate_Holiday__c',
          type: 'number'
        },
        "Vendor_FTE_Hourly_Rate_Overtime__c": {
          name: 'Vendor_FTE_Hourly_Rate_Overtime__c',
          type: 'number'
        },
        "Vendor_FTE_Monthly_Rate__c": {
          name: 'Vendor_FTE_Monthly_Rate__c',
          type: 'number'
        },
        "Vendor_Hourly_Rate__c": {
          name: 'Vendor_Hourly_Rate__c',
          type: 'number'
        },
        "GrossMargin__c": {
          name: 'GrossMargin__c',
          type: 'number'
        },
        "Vendor_FTE_Weekly_Rate__c": {
          name: 'Vendor_FTE_Weekly_Rate__c',
          type: 'number'
        },
        "TPMO_Approval_Check__c": {
          name: 'TPMO_Approval_Check__c',
          type: 'boolean'
        },
        "TPMO_Approval__c": {
          name: 'TPMO_Approval__c',
          type: 'string'
        },
        "Joining_Bonus__c": {
          name: 'Joining_Bonus__c',
          type: 'number'
        },
        "MBO_Bonus__c": {
          name: 'MBO_Bonus__c',
          type: 'number'
        },
        "Other_Bonus__c": {
          name: 'Other_Bonus__c',
          type: 'number'
        },
        "Offered_Vacation_PTOs__c": {
          name: 'Offered_Vacation_PTOs__c',
          type: 'number'
        },
        "Offered_Sick_Leaves__c": {
          name: 'Offered_Sick_Leaves__c',
          type: 'number'
        },
        "Public_holidays__c": {
          name: 'Public_holidays__c',
          type: 'number'
        },
        "Health_Insurance__c": {
          name: 'Health_Insurance__c',
          type: 'string'
        },
        "Health_Insurance_Contribution__c": {
          name: 'Health_Insurance_Contribution__c',
          type: 'string'
        },
        "Any_Other_Benefit__c": {
          name: 'Any_Other_Benefit__c',
          type: 'string'
        },
        "Does_this_candidate_now_or_in_future_nee__c": {
          name: 'Does_this_candidate_now_or_in_future_nee__c',
          type: 'string'
        },
        "Job_Status__c": {
          name: 'Job_Status__c',
          type: 'string'
        },
        "Hiring_Entity_Name__c": {
          name: 'Hiring_Entity_Name__c',
          type: 'string'
        },
        "Hiring_Entity_Country__c": {
          name: 'Hiring_Entity_Country__c',
          type: 'string'
        },
        "Relocation_Expense_In_Any__c": {
          name: 'Relocation_Expense_In_Any__c',
          type: 'number'
        },
        "Standard_Benefit_Packet__c": {
          name: 'Standard_Benefit_Packet__c',
          type: 'string'
        },
        "Dental_Coverage__c": {
          name: 'Dental_Coverage__c',
          type: 'number'
        },
        "Budget_for_Counter_Offer__c": {
          name: 'Budget_for_Counter_Offer__c',
          type: 'number'
        },
        "Medical_Coverage__c": {
          name: 'Medical_Coverage__c',
          type: 'number'
        },
        "Vision_Coverage__c": {
          name: 'Vision_Coverage__c',
          type: 'number'
        },
        "SOW_Detail__c": {
          name: 'SOW_Detail__c',
          type: 'string'
        },
        "RTR_End_Date__c": {
          name: 'RTR_End_Date__c',
          type: 'Date'
        },
        "RTR_Start_Date__c": {
          name: 'RTR_Start_Date__c',
          type: 'Date'
        },
        "FTE_Employment_Category__c": {
          name: 'FTE_Employment_Category__c',
          type: 'string'
        },
        "Bypass_RTR__c": {
          name: 'Bypass_RTR__c',
          type: 'boolean',
          default: false
        },
        "Candidate_Vaccination_Status__c": {
          name: 'Candidate_Vaccination_Status__c',
          type: 'string'
        },
        "Bypass_Covid_Vaccination_Check__c": {
          name: 'Bypass_Covid_Vaccination_Check__c',
          type: 'boolean',
          default: false
        },
        "Reason_for_Covid_Vaccination_Bypass__c": {
          name: 'Reason_for_Covid_Vaccination_Bypass__c',
          type: 'string'
        },
        "Right_to_Represent__c": {
          name: 'Right_to_Represent__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'ts2__Account__c',
          keyTo: 'sfdcId'
        },
        contact: {
          name: 'contact',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'ts2__Candidate_Contact__c',
          keyTo: 'sfdcId'
        },
        hrManager: {
          name: 'hrManager',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'Hiring_Manager__c',
          keyTo: 'sfdcId'
        },
        geoMetro: {
          name: 'geoMetro',
          type: 'GeoMetro',
          model: 'GeoMetro',
          relationType: 'belongsTo',
                  keyFrom: 'GEO_Code__c',
          keyTo: 'Name'
        },
        createdBy: {
          name: 'createdBy',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'CreatedBy__c',
          keyTo: 'sfdcId'
        },
        agency: {
          name: 'agency',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'ts2__Agency__c',
          keyTo: 'sfdcId'
        },
        tasks: {
          name: 'tasks',
          type: 'Task[]',
          model: 'Task',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Application__c'
        },
        primaryRecruiter: {
          name: 'primaryRecruiter',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'Primary_Recruiter__c',
          keyTo: 'sfdcId'
        },
        lastModifiedBy: {
          name: 'lastModifiedBy',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'LastModifiedBy__c',
          keyTo: 'sfdcId'
        },
        worker: {
          name: 'worker',
          type: 'Worker',
          model: 'Worker',
          relationType: 'belongsTo',
                  keyFrom: 'Finance_Approver_Name__c',
          keyTo: 'sfdcId'
        },
        hiringEntityCountry: {
          name: 'hiringEntityCountry',
          type: 'CountryCode',
          model: 'CountryCode',
          relationType: 'belongsTo',
                  keyFrom: 'Hiring_Entity_Country__c',
          keyTo: 'sfdcId'
        },
        jobOffers: {
          name: 'jobOffers',
          type: 'JobOffers[]',
          model: 'JobOffers',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'ts2__Related_Application__c'
        },
        jobOrder: {
          name: 'jobOrder',
          type: 'JobOrder',
          model: 'JobOrder',
          relationType: 'belongsTo',
                  keyFrom: 'ts2__Job__c',
          keyTo: 'sfdcId'
        },
        source: {
          name: 'source',
          type: 'Source',
          model: 'Source',
          relationType: 'belongsTo',
                  keyFrom: 'ts2__Application_Source__c',
          keyTo: 'sfdcId'
        },
        applicationAssesment: {
          name: 'applicationAssesment',
          type: 'ApplicationAssessment[]',
          model: 'ApplicationAssessment',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Application__c'
        },
        vendorSows: {
          name: 'vendorSows',
          type: 'SOWDetail',
          model: 'SOWDetail',
          relationType: 'belongsTo',
                  keyFrom: 'SOW_Detail__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
